import {
  Box,
  Card,
  CardContent,
  CardProps,
  Stack,
  Typography,
} from "@mui/material";
import React, { ReactNode } from "react";
import { fontSizes } from "../../theme";
import RoundIcon from "../RoundIcon";

interface CardWithIconProps extends CardProps {
  icon: React.ReactNode;
  title: string;
  description: string | ReactNode;
}

const CardWithIcon: React.FC<CardWithIconProps> = ({
  icon,
  title,
  description,
  ...rest
}) => {
  return (
    <Box
      sx={{
        padding: 0,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box>
        <RoundIcon>{icon}</RoundIcon>
      </Box>
      <Stack width={"100%"} spacing={0}>
        <Typography fontWeight={"medium"} fontSize={fontSizes.lg}>
          {title}
        </Typography>
        <Typography fontWeight={"normal"} fontSize={fontSizes.xs}>
          {description}
        </Typography>
      </Stack>
    </Box>
  );
};

export default CardWithIcon;
